import { axiosGetNoAuth, axiosPostAuth, axiosPostNoAuth } from "../utils/common/axios";

// Local (non-SSO) authentication. Paths are relative to REACT_APP_BACKEND_URL, which already ends
// in /api/.
//
// Two call flavours, not interchangeable:
//   axiosPostAuth    - withCredentials + X-Device-Id, for endpoints that set/send the HttpOnly
//                      refresh cookie (LMS contract, not live here yet).
//   axiosPostNoAuth/ - public and cookie-free.
//   axiosGetNoAuth
const base = "v1/auth";

export const authApi = {
  // LIVE. {userName, password} -> {jwtToken, userName, brand | manufacturer}. No refresh token -
  // the JWT carries its own `exp`. 404 "Brand not found" / "Manufacturer not found" for an
  // unknown userName, 500 "Invalid username or password" for a wrong password.
  brandLogin: (payload) => axiosPostNoAuth("auth/login", payload),
  manufacturerLogin: (payload) => axiosPostNoAuth("auth/manufacturer/login", payload),

  // Everything below is the LMS contract (lms-kriha-frontend AUTH-LOGIN-REVAMP.md §3.4), NOT live
  // on the Garment backend yet. OTP and signup are switched off in auth/config.js; reconcile these
  // paths when the backend ships them.

  // {email} -> {message, expiresInSeconds, resendAfterSeconds, maskedEmail}
  requestLoginOtp: (payload) => axiosPostNoAuth(`${base}/otp/request`, payload),
  // {email, otp, rememberMe} -> AuthTokenResponse + refresh cookie.
  verifyLoginOtp: (payload) => axiosPostAuth(`${base}/otp/verify`, payload),

  // {email} -> same shape as requestLoginOtp
  forgotPassword: (payload) => axiosPostNoAuth(`${base}/password/forgot`, payload),
  // {email, otp} -> {resetToken, expiresInSeconds}
  verifyForgotPasswordOtp: (payload) => axiosPostNoAuth(`${base}/password/forgot/verify`, payload),
  // {resetToken, password, confirmPassword} -> {message}
  resetPassword: (payload) => axiosPostNoAuth(`${base}/password/reset`, payload),
  // -> {valid:true, email, firstName}; 410 TOKEN_ALREADY_USED / TOKEN_EXPIRED
  getPasswordSetup: (token) => axiosGetNoAuth(`${base}/password/setup/${encodeURIComponent(token)}`),
  // {token, password, confirmPassword} -> {message}
  setupPassword: (payload) => axiosPostNoAuth(`${base}/password/setup`, payload),

  // {email, firstName, lastName} -> OTP sent. 403 SIGNUP_DISABLED | 409 EMAIL_ALREADY_REGISTERED
  signupRequest: (payload) => axiosPostNoAuth(`${base}/signup/request`, payload),
  // {email, otp, password, confirmPassword} -> AuthTokenResponse + refresh cookie
  signupVerify: (payload) => axiosPostAuth(`${base}/signup/verify`, payload),
};
